import { useState } from "react"
import { Palette } from "lucide-react"

import { ThemeSwitcher } from "@/components/theme-switcher"

// Header-mounted theme control. A single palette icon-button toggles a popover
// holding the (unchanged) ThemeSwitcher, so the theme controls never crowd the
// brand on a narrow bar yet stay one click away on every page.
export function ThemeMenu() {
  const [open, setOpen] = useState(false)

  return (
    <div className="relative">
      <button
        type="button"
        aria-label="Theme"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center justify-center rounded-md border border-input bg-card p-2 text-foreground shadow-sm transition-colors hover:bg-accent/10 focus:outline-none focus:ring-2 focus:ring-ring"
      >
        <Palette className="size-4" />
      </button>
      {open && (
        <div className="absolute right-0 z-20 mt-2 rounded-md border border-border bg-card p-4 shadow-md">
          <ThemeSwitcher />
        </div>
      )}
    </div>
  )
}
